import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { faker } from '@faker-js/faker';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: false,
      text: 'Chart.js Line Chart',
    },
         legend: {
        display: false, // Hide the legend
      },
  },
};

const labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'];

export const data = {
  labels,
  datasets: [
    {
      label: 'Dataset 1',
      data: labels.map(() => faker.datatype.number({ min: -1000, max: 1000 })),
      borderColor: 'rgb(156 200 241)',
      backgroundColor: 'rgb(156 200 241)',
    },
    {
      label: 'Dataset 2',
      data: labels.map(() => faker.datatype.number({ min: -1000, max: 1000 })),
      borderColor: 'rgb(129 235 231)',
      backgroundColor: 'rgb(129 235 231)',
    },
     {
      label: 'Dataset 2',
      data: labels.map(() => faker.datatype.number({ min: -1000, max: 1000 })),
      borderColor: 'rgb(247 209 169)',
      backgroundColor: 'rgb(247 209 169)',
    },

    
  ],
};

export default function LineChartView() {

  return (
     <div style={{  width: '500px', height: '290px' }}>
       <div className='flex flex-col space-y-3 mb-10'>
<span className='text-[#c9c9c9] '>Data Anlysis</span>
</div>


    <Line options={options} data={data} />
    </div>)
}
